import React, {useContext, useEffect, useState, useCallback} from 'react'
import { NavigationContext } from '../../../context/navigation-context'
import { Link } from 'react-router-dom'
import useFetch from '../../../hooks/fetchMSSQL-hook'
import useForm from '../../../hooks/form-hook'
import RecipesTable from './components/RecipesTable'
import SearchFilter from '../../../components/Filter/SearchFilter'
import RecipeForm from '../../../components/Modals/RecipeForm'
import sampleProduct from '../../../assets/images/sample-product.svg'
import { API_URL } from '../../../config/config'

const Recipes = () => {
  const { fetchMssqlApi } = useFetch();
  const { setHeaderData } = useContext(NavigationContext);
  const [recipes, setRecipes] = useState([]);
  const { form, openForm, closeForm } = useForm();

  const defaultFilter = {
    page: 1,
    rowsPerPage: 50,
    sortBy: "none",
    recipeId: null,
    eanRName: null,
    recipeName: "",
    vatCode: null,
    isActive: "true",
    depositName: "",
    depositId: null,
  }

  const [filter, setFilter] = useState(defaultFilter);
  const [settingsFilter, setSettingsFilter] = useState();

  const sortDefaults = {
    EAN: "ASC",
    Name: "ASC",
    IsActive: "DESC",
    VATCode: "ASC",
    DepositName: "ASC",
  };

  const handleHeaderSort = (field) => {
    const [curField, curDirRaw] = String(filter.sortBy || "none").split("|");
    const curDir = (curDirRaw || "").toUpperCase();
    let sortBy;
    let sortByName=""
    if (curField !== field) {sortBy = `${field}|DESC`;
    } else if (curDir === "DESC") {sortBy = `${field}|ASC`;
    } else if (curDir === "ASC") {sortBy = "none";
    } else sortBy = `${field}|DESC`;
    const next = { ...filter, sortBy, page: 1 };
    setFilter(next);
    search(next, settingsFilter.rowsPerPage, 1, true);
  };

  const parseThreeState = (val) => {
    if (val === "true") return true;
    if (val === "false") return false;
    return null;
  };

  const getProductIdsByTags = (productTagIds) => {
    return new Promise((resolve, reject) => {
      fetchMssqlApi(
        "getProductIdsByTags",
        { method: "POST", hideNotification: true, data: { productTagIds } },
        (response) => { resolve(JSON.stringify(response.map(Number).filter(Number.isFinite)) || [])},
        (err) => reject(err)
      );
    });
  };

  const search = async (f, pageSize, page) => { 
    let rowsPerPage = settingsFilter?.rowsPerPage ?? 100;
    if (pageSize != null || pageSize != undefined) rowsPerPage = pageSize;
    const pageNo = Math.max(1, Number(page ?? f?.page) || 1);
    let recipeIds = "[]";
    if (f?.recipeTags?.id?.length > 0) { recipeIds = await getProductIdsByTags(f.recipeTags.id)}
    if (f?.recipeId) {const arr = JSON.parse(recipeIds); arr.push(Number(f.recipeId)); recipeIds = JSON.stringify(arr)}
    fetchMssqlApi('recipes', {method: "POST", hideNotification: true, showLoader: true, data: {
      recipeId: recipeIds,
      vatCode: f?.VATCode,
      isActive: parseThreeState(f?.isActive),
      depositId: f?.depositId,
      pageSize: rowsPerPage,
      pageNo: pageNo,
      sortBy: f?.sortBy
    }}, (res) => setRecipes(res || []));
  };

  const handleSearchFilterChange = useCallback((f) => {
    setFilter(prev =>
      JSON.stringify(prev || {}) === JSON.stringify(f || {}) ? prev : f
    );
  }, []);

  useEffect(() => {
    setHeaderData({text: "Receptury"});
  }, []);

  return (
    <div className="container-fluid p-0 filter-icon-fix">
      <ul className="nav nav-tabs machine-tabs mb-1">
        <li className="nav-item">
          <Link to="/products">
            <button className={`nav-link btn`} tabIndex="0">
              Produkty
            </button>
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/recipes">
            <button className={`nav-link btn active`} tabIndex="0">
              Receptury
            </button>
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/categories">
            <button className={`nav-link btn`} tabIndex="0">
              Kategorie
            </button>
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/deposits">
            <button className={`nav-link btn`} tabIndex="0">
              Kaucje
            </button>
          </Link>
        </li>
      </ul>
      <SearchFilter
        filterName={"recipes"}
        defaultFilter={defaultFilter}
        searchFilter={filter}
        onFilterChange={handleSearchFilterChange}
        onSettingsChange={(s) => setSettingsFilter(s)} 
        search={search}
        totalCount={recipes.length}
        forNow
      />
      <RecipesTable
        recipes={recipes}
        openForm={openForm()}
        API_URL={API_URL}
        sampleProduct={sampleProduct}
        sortBy={filter.sortBy}
        handleHeaderSort={handleHeaderSort}
      />
      <RecipeForm
        handleClose={closeForm}
        form={form}
        onAdded={() => search(filter, settingsFilter?.rowsPerPage, 1)}
      />
    </div>
  );
};

export default Recipes;